export default {"src":"/login-app/[GIT_HASH]/_next/static/media/info.a7ea0e91.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};